import { render, staticRenderFns } from "./standardButton.vue?vue&type=template&id=33a0e17d"
import script from "./standardButton.vue?vue&type=script&lang=js"
export * from "./standardButton.vue?vue&type=script&lang=js"
import style0 from "./standardButton.vue?vue&type=style&index=0&id=33a0e17d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports